var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text",style:({color:_vm.fontColor})},[_vm._v("No Data")])
}
var staticRenderFns = []

export { render, staticRenderFns }